"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeIdsFromSelectedIdsAction = exports.reducer = exports.getNumberOfIssueTableSelectedIds = exports.getIssueTableSelectedIds = exports.clearSelectedIdsAction = exports.addIdsToSelectedIdsAction = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
/**
 * We want to avoid putting non-serializable values into the Redux store state, so we use an array instead of a set.
 * More details here: https://redux.js.org/style-guide/style-guide#do-not-put-non-serializable-values-in-state-or-actions
 */

const initialState = {
  selectedIssueIds: []
};
const issueTableSelectionSlice = (0, _toolkit.createSlice)({
  name: "issueTableSelection",
  initialState,
  reducers: {
    addIdsToSelectedIdsAction: (state, action) => {
      const selectedIssueIdSet = new Set(state.selectedIssueIds);
      action.payload.issueUids.forEach(issueUid => {
        selectedIssueIdSet.add(issueUid);
      });
      state.selectedIssueIds = [...selectedIssueIdSet];
    },
    removeIdsFromSelectedIdsAction: (state, action) => {
      const selectedIssueIdSet = new Set(state.selectedIssueIds);
      action.payload.issueUids.forEach(issueUid => {
        selectedIssueIdSet.delete(issueUid);
      });
      state.selectedIssueIds = [...selectedIssueIdSet];
    },
    clearSelectedIdsAction: state => {
      state.selectedIssueIds = [];
    }
  }
});
const {
  addIdsToSelectedIdsAction,
  removeIdsFromSelectedIdsAction,
  clearSelectedIdsAction
} = issueTableSelectionSlice.actions;
exports.clearSelectedIdsAction = clearSelectedIdsAction;
exports.removeIdsFromSelectedIdsAction = removeIdsFromSelectedIdsAction;
exports.addIdsToSelectedIdsAction = addIdsToSelectedIdsAction;
const reducer = exports.reducer = issueTableSelectionSlice.reducer;
const STATE_KEY = exports.STATE_KEY = issueTableSelectionSlice.name;
const getIssueTableSelectionState = state => state[STATE_KEY];
const getIssueTableSelectedIds = exports.getIssueTableSelectedIds = (0, _toolkit.createSelector)(getIssueTableSelectionState, state => state.selectedIssueIds);
const getNumberOfIssueTableSelectedIds = exports.getNumberOfIssueTableSelectedIds = (0, _toolkit.createSelector)(getIssueTableSelectedIds, selectedIssueIds => selectedIssueIds.length);
//# sourceMappingURL=issueTableSelection.js.map